import xpSolvService from "../axios/axios";

class SharedService {

    
}

export default SharedService;